module.exports = __webpack_public_path__ + "static/media/business_insights.f429438f.svg";